module.exports = __webpack_public_path__ + "img/x.4390e8f6.svg";